import { render, staticRenderFns } from "./informe-propuesta.vue?vue&type=template&id=12c9b033&scoped=true"
import script from "./informe-propuesta.vue?vue&type=script&lang=js"
export * from "./informe-propuesta.vue?vue&type=script&lang=js"
import style0 from "./informe-propuesta.vue?vue&type=style&index=0&id=12c9b033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9b033",
  null
  
)

export default component.exports